// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxTalking_container__3aCN6","default":"BoxTalking_default__1a5Vw","message":"BoxTalking_message__3CJnS","topSpinner":"BoxTalking_topSpinner__2GFAt"};